<template>
  <mu-container class="container animated slideInDown">
    <mu-paper class="demo-list-wrap">
      <mu-list v-if="typeof data !== 'string'" textline="two-line">
        <div v-for="item in data" :key="item.id">
          <mu-list-item
            :to="{
              path: '/answer-result',
              query: { answer_id: item.id, type: 'test' },
            }"
            :ripple="false"
            avatar
            button
          >
            <mu-list-item-content>
              <mu-list-item-title>{{ item.title }}</mu-list-item-title>
              <mu-list-item-sub-title>
                得分:
                <span :style="{ color: item.score >= 60 ? 'green' : 'red' }">
                  {{ item.score }}
                </span>
              </mu-list-item-sub-title>
            </mu-list-item-content>
            <mu-list-item-action>
              <mu-list-item-after-text>
                {{ item.end_time }}
              </mu-list-item-after-text>
              <!-- <mu-badge :content="item.type === 3 ? '模拟考试' : '模拟考试'"></mu-badge> -->
            </mu-list-item-action>
          </mu-list-item>
          <mu-divider></mu-divider>
        </div>
      </mu-list>
      <div v-if="showError" class="bg-info">
        <br />
        <br />
        <br />
        <mu-icon size="96" value="info" color="info"></mu-icon>
        <p class="text-center">暂无考试记录</p>
      </div>
    </mu-paper>
  </mu-container>
</template>

<script>
import { fetchMockTestRecordsHistoryList } from '@/api/index'

export default {
  components: {},
  props: {},
  data() {
    return {
      data: '',
      showError: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  async mounted() {
    this.data = await fetchMockTestRecordsHistoryList().catch(
      () => (this.showError = true)
    )
    if (Array.isArray(this.data) && this.data.length <= 0) {
      this.showError = true
    }
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {},
  filter: {},
}
</script>

<style lang="scss" scoped>
.container {
  padding: {
    left: 0;
    right: 0;
  }
  background: #fff;
  p {
    margin: 8px 0;
  }
}
.mu-list {
  padding: 0;
}
</style>
<style lang="scss"></style>
